const EXCEPTION_KEY_DELIMITER = '_'

const normalizePart = (value) =>
  typeof value === 'string' ? value.trim() : value ?? ''

export const toExceptionKey = ({
  agreementNumber,
  cardNumber,
  cardnumber,
  customerName,
  exception,
  invoiceDate,
  product,
  thirdPartyNumber,
  transactionDate,
  transactionTime,
  vehicleRegistration,
} = {}) => {
  const cardNum = cardNumber ?? cardnumber ?? ''

  const parts = [
    agreementNumber,
    cardNum,
    customerName,
    exception,
    invoiceDate,
    product,
    thirdPartyNumber,
    transactionDate,
    transactionTime,
    vehicleRegistration,
  ].map(normalizePart)

  return parts.join(EXCEPTION_KEY_DELIMITER)
}

export const parseExceptionKey = (compositeKey = '') => {
  const [
    agreementNumber = '',
    cardNumber = '',
    customerName = '',
    exception = '',
    invoiceDate = '',
    product = '',
    thirdPartyNumber = '',
    transactionDate = '',
    transactionTime = '',
    vehicleRegistration = '',
  ] = compositeKey.split(EXCEPTION_KEY_DELIMITER)

  return {
    agreementNumber,
    cardnumber: cardNumber,
    customerName,
    exception,
    invoiceDate,
    product,
    thirdPartyNumber,
    transactionDate,
    transactionTime,
    vehicleRegistration,
  }
}

const selectableStatuses = new Set([
  'draft',
  'pending review',
])

export const isSelectableStatus = (status) => {
  if (typeof status !== 'string') {
    return false
  }

  return selectableStatuses.has(status.trim().toLowerCase())
}

export const hasCompleteExceptionIdentity = (value = {}) => {
  const {
    agreementNumber,
    transactionDate,
    transactionTime,
    cardnumber,
    cardNumber,
    exception,
  } = value

  const card = cardnumber ?? cardNumber ?? ''
  const exc = exception ?? ''

  return [agreementNumber, transactionDate, transactionTime, card, exc].every(Boolean)
}
